import {SET_SETTING} from "../actions/types";

const initialState = {};

export default function setting(state = initialState, action) {
    const {type, payload} = action;

    switch (type) {
        case SET_SETTING:
            const currenciesArray = payload.CURRENCIES.split(',');
            const providers = [...new Set(
                Object.keys(payload)
                    .filter(key => key.endsWith('_PAYMENT_FEES_RATE'))
                    .map(key => key.replace('_PAYMENT_FEES_RATE', ''))
                    .map(provider => provider.startsWith('STRIPE') ? 'STRIPE' : provider)
            )];
            payload.CURRENCIES = currenciesArray
            payload.PROVIDERS = providers
            const sourceCurrencies = Object.getOwnPropertyNames(payload)
                .filter(key => key.startsWith('SOURCE_CURRENCIES_'))
                .reduce((acc, key) => {
                    const currency = key.replace('SOURCE_CURRENCIES_', '');
                    acc[currency] = payload[key].split(',').map(s => s.trim());
                    return acc;
                }, {});
            const targetCurrencies = Object.getOwnPropertyNames(payload)
                .filter(key => key.startsWith('DESTINATION_CURRENCIES_'))
                .reduce((acc, key) => {
                    const currency = key.replace('DESTINATION_CURRENCIES_', '');
                    acc[currency] = payload[key].split(',').map(s => s.trim());
                    return acc;
                }, {});
            payload.SOURCE_CURRENCIES = sourceCurrencies
            payload.TARGET_CURRENCIES = targetCurrencies
            return payload;
        default:
            return state;
    }
}
